import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Bell, AlertTriangle, AlertCircle, CheckCheck } from "lucide-react";

const ICON = (type) => type === "cert_expired"
  ? <AlertCircle className="w-5 h-5 text-rose-600" />
  : type === "cert_expiring"
  ? <AlertTriangle className="w-5 h-5 text-amber-600" />
  : <Bell className="w-5 h-5 text-[var(--unigr-navy)]" />;

export default function Notifications() {
  const [items, setItems] = useState([]);

  const refresh = async () => {
    const { data } = await api.get("/notifications/me");
    setItems(data);
  };
  useEffect(() => { refresh(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); refresh(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); refresh(); };

  return (
    <div className="space-y-8" data-testid="notifications-page">
      <header className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="eyebrow">Avisos</div>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Notificações</h1>
          <p className="text-slate-600 mt-2 text-sm">Reciclagens, vencimentos e alertas operacionais.</p>
        </div>
        <Button variant="outline" onClick={markAll} data-testid="mark-all-read-btn"><CheckCheck className="w-4 h-4 mr-2" />Marcar todas como lidas</Button>
      </header>

      {items.length === 0 ? (
        <Card><CardContent className="p-10 text-center text-slate-600">
          <Bell className="w-10 h-10 mx-auto text-slate-400 mb-3" />
          Sem notificações por enquanto.
        </CardContent></Card>
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <Card key={n.id} className={n.read ? "border-[var(--unigr-border)]" : "border-l-4 border-l-[var(--unigr-red)]"} data-testid={`notif-${n.id}`}>
              <CardContent className="p-5 flex items-start gap-4">
                <div className="pt-0.5">{ICON(n.type)}</div>
                <div className="flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="font-display font-bold">{n.title}</div>
                      <div className="text-sm text-slate-600 mt-1">{n.message}</div>
                      <div className="text-xs text-slate-400 mt-2">{(n.created_at || "").replace("T", " ").slice(0, 16)}</div>
                    </div>
                    {!n.read && <Badge className="bg-[var(--unigr-red)] text-white border-0">Nova</Badge>}
                  </div>
                  <div className="flex gap-2 mt-3">
                    {n.link && <Link to={n.link}><Button size="sm" className="btn-navy" data-testid={`notif-action-${n.id}`}>Acessar treinamento</Button></Link>}
                    {!n.read && <Button size="sm" variant="outline" onClick={() => markOne(n.id)}>Marcar como lida</Button>}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
